import { useState, useEffect } from 'react';

export const useMarkdownContent = (filename) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/${filename}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch ${filename}`);
        }
        const text = await response.text();
        // Remove any HTML comments that might have been left in the markdown
        const cleanedText = text.replace(/<!--[\s\S]*?-->/g, '');
        setContent(cleanedText);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [filename]);

  return { content, loading, error };
};
